(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-novel-journey-videos"] && !Shopify.designMode) return;
  try {
    class PDPNovelJourneyVideo extends HTMLElement {
    constructor() {
      super();
      this.collapsibleRow = this.querySelector('collapsible-row');
      this.novelJourneyId = this.dataset.novelJourneyId;
      this.apiBaseUrl = 'https://eg2o7r7cs9.execute-api.us-west-2.amazonaws.com/prod';
    }

    connectedCallback() {
      this.container = this.querySelector('#novel-journey-video-container');
      this.getReleases();
    }

    disconnectedCallback() {}

    async getReleases() {
      let apiEndpoint = `${this.apiBaseUrl}/api/v2/journeys/${this.novelJourneyId}/releases?type=PUBLISH&sort=createdAt&order=DESC&size=1`;
      try {
        const req = await fetch(apiEndpoint);
        const res = await req.json();
        if (res.length === 0) {
          this.hideComponent();
          return;
        }
        this.loadScript();
        this.showContent();
      } catch (error) {
        console.error(`PDP Novel Journey Videos | ${error}`);
      }
    }

    loadScript() {
      const embedJsUrl = 'https://embed-js.benovel.com/embed/index.js';
      const script = document.createElement('script');
      script.setAttribute('src', embedJsUrl);
      script.setAttribute('journey-id', this.novelJourneyId);
      script.setAttribute('async', '');
      this.container.appendChild(script);
    }

    hideComponent() {
      this.classList.add('hide-novel-journey');
    }

    showComponent() {
      this.classList.remove('hide-novel-journey');
    }

    showContent() {
      this.showComponent();
    }
  }
  customElements.define('pdp-novel-journey-videos', PDPNovelJourneyVideo);
  } catch(e) { console.error(e); }
})();

})();
